import e from"../../../../node_modules/style-inject/dist/style-inject.es.js";var t=".index-module_textDate__QYWPq {\n  /** Fake content for empty theme classes (used by atsm). */\n}";var s={textDate:"index-module_textDate__QYWPq"};e(t);export{s as default};
//# sourceMappingURL=index.module.scss.js.map
